import React, { useEffect } from 'react';
import { Cards } from '@cloudscape-design/components';
import BreadcrumbGroup from '@cloudscape-design/components/breadcrumb-group';
import Header from '@cloudscape-design/components/header';
import { CustomAppLayout } from '../../layout';
import { useRouter } from '../../router';
import { useStore } from '../../store';
import { mdiEmailFast, mdiViewList, mdiEmailLock, mdiEmail } from '@mdi/js';
import Icon from '@mdi/react';

const pageSize = 20;

export const InvitationsPage = () => {
    const {
        actions: { makeHelpPanelHandler },
    } = useStore();
    const { navigate } = useRouter();



    useEffect(() => {
        //handleRefresh();
    }, []);
    const handleOption = (ref: string) => {
        window.location.href = ref
    }
    return (
        <CustomAppLayout
            toolsHide={true}
            breadcrumbs={
                <BreadcrumbGroup
                    items={[
                        { text: 'Inicio', href: '#home' },
                        { text: 'Invitaciones', href: '#transcription-job-list' },
                    ]}
                    expandAriaLabel="Show path"
                    ariaLabel="Breadcrumbs"
                />
            }
            content={
                <>

                    <Cards
                        selectionType="single"
                        onSelectionChange={({ detail }) => handleOption(detail.selectedItems[0].id)}
                        cardDefinition={{

                            header: item => item.name
                            ,
                            sections: [
                                {
                                    header: "",
                                    content: item => item.description
                                },
                            ]
                        }}
                        cardsPerRow={[
                            { cards: 1 },
                            { minWidth: 500, cards: 3 }
                        ]}
                        entireCardClickable
                        items={[
                            {
                                id: "#invitations/add",
                                name: (<span>
                                    <Icon path={mdiEmailFast} size={1.5} /> Agregar</span>),
                                description: "Generar una nueva invitación para un usuario",
                            },
                            {
                                id: "#invitations/list",
                                name: (<span>
                                    <Icon path={mdiViewList} size={1.5} /> Listado</span>),
                                description: "Invitaciones las cuales se encuentra activas o recientemente expipradas",
                            },
                            {
                                id: "#invitations/authorize",
                                name: (<span>
                                    <Icon path={mdiEmailLock} size={1.5} /> Autorización</span>),
                                description: "Invitaciones que exceden el número máximo de invitados y requieren autorización",
                            },
                        ]}

                        header={<Header><Icon path={mdiEmail} size={2} /> Invitaciones</Header>}
                    />
                </>
            }
        />
    );
};
